import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const HomeDashboard = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex flex-col gap-6">
        <Card className="rounded-2xl border-0 bg-white shadow-sm">
          <CardContent className="p-6">
            <div className="flex flex-col items-start gap-3">
              <h2 className="text-lg font-semibold text-slate-700">Home</h2>
              <p className="text-slate-600">Halaman utama untuk navigasi cepat ke dashboard workspace dan modul penting.</p>
              <div className="flex flex-wrap gap-3">
                <Button onClick={() => navigate('/admin/ieem-dashboard')}>IEEM Dashboard</Button>
                <Button variant="outline" onClick={() => navigate('/admin/product-dashboard')}>
                  Product Dashboard
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="rounded-2xl border-0 bg-white shadow-sm">
          <CardContent className="p-6">
            <h2 className="mb-4 text-sm font-semibold text-slate-700">Shortcut Operasional</h2>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
              <Button variant="outline" onClick={() => navigate('/admin/package-manager/my-packages')}>
                My Packages
              </Button>
              <Button variant="outline" onClick={() => navigate('/admin/package-manager/product-catalog')}>
                Product Catalog
              </Button>
              <Button variant="outline" onClick={() => navigate('/admin/manage-users')}>
                Manage Users
              </Button>
              <Button variant="outline" onClick={() => navigate('/admin/master-data/menu')}>
                Master Data Menu
              </Button>
              <Button variant="outline" onClick={() => navigate('/admin/master-data/menu-category')}>
                Menu Categories
              </Button>
              <Button variant="outline" onClick={() => navigate('/admin/master-data/menu-subcategory')}>
                Menu Sub-Categories
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default HomeDashboard;
